import { render, staticRenderFns } from "./SelectModalGoodsForm.vue?vue&type=template&id=07a4f1bd&scoped=true"
import script from "./SelectModalGoodsForm.vue?vue&type=script&lang=js"
export * from "./SelectModalGoodsForm.vue?vue&type=script&lang=js"
import style0 from "./SelectModalGoodsForm.vue?vue&type=style&index=0&id=07a4f1bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a4f1bd",
  null
  
)

export default component.exports